const iframeOrigin = `https://bridge.logictry.com`;

class BroadcastChannel {
  constructor() {
    this.tab = (Math.floor(Math.random() * 10000000000000000)).toString();
    this.iframe = document.createElement('iframe');
    this.iframe.src = iframeOrigin;
    this.iframe.style.display = 'none';
    document.body.appendChild(this.iframe);
  }
  postMessage(data) {
    this.iframe.contentWindow.postMessage(
      JSON.stringify({
        ...data,
        tab: this.tab
      }),
      '*',
    );
  }
}
const singleton = new BroadcastChannel();
export default singleton;
